import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { Service } from 'shell/models/service';
import { TownHall } from 'shell/models/town-hall';
import { ServiceForm } from 'system/components/services/form';
import { MunicipalityVM } from 'system/view-models/municipality';

export const transformerService = (response: AxiosResponse<HttpResponse<Service>>): ServiceForm => {
  const data = response.data.payload;
  return {
    name: data?.descrizione || '',
    phoneNumber: data?.telefono || '',
    shortDescription: data?.descrizioneBreve || '',
    streetNumber: data?.civico?.toString() || '',
    code: data?.key?.codiceServizio || '',
    civicRepresentative: data?.esponente || '',
    contextLastUpdate: data?.note || '',
    zoneCode: data?.zona,
    areaCircolazione: data.areaCircolazione, // utile per chiamata a getCirculationArea
    managementCash: data.gestioneCassa === 'S',
    pec: data?.pec || '',
    peo: data?.peo || '',
  };
};

export const transformerTownHall = (
  response: AxiosResponse<HttpResponse<TownHall>>
): MunicipalityVM => {
  const data = response.data.payload;
  return {
    code: data.key?.codice,
    description: data?.descrizioneBreve,
  };
};
